<template>
    <div class="mask" v-if="videoVisible"></div>
    <div class="video-container" v-if="videoVisible">
        <div class="close" @click="$emit('cancel')"><close-circle-outlined /></div>
        <div class="title">{{ title }}视频监控</div>
        <div class="camera-btn">
            <a-radio-group v-model:value="videoSelectValue" @change="videoChange">
                <a-space>
                    <a-radio-button v-for="(item, i) in videoList" :key="i" :value="item">{{ i+1 }}号监控</a-radio-button>
                </a-space>
            </a-radio-group>
        </div>
        <div class="videos">
            <player ref="windowPlayerPlayRef" :id="'node_windowPlayer'"></player>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { CloseCircleOutlined } from '@ant-design/icons-vue'
import player from "./player"
import {ref} from "vue";
export default {
    name: "windowPlayer",
    props: {
        videoVisible: Boolean,
        title: String
    },
    setup(props, { emit }) {
        const videoSelectValue = ref('0') // 监控按钮
        const videoList = ref([])
        const handleCancel = () => {
            emit('cancel', )
        }
        return {
            handleCancel,
            videoSelectValue,
            videoList
        }
    },
    methods: {
        videoChange(e) {
            this.$nextTick(() => {
                this.$refs.windowPlayerPlayRef.play(e.target.value)
            })
        },
        init(list) {
            this.videoList = list
            this.$nextTick(() => {
                this.videoSelectValue = this.videoList[0]
                this.$refs.windowPlayerPlayRef.play(this.videoList[0])
            })
        }
    },
    components: {
        CloseCircleOutlined,
        player
    }
}
</script>

<style scoped lang="stylus">
    .mask {
        width 100vw
        height 100vh
        position fixed
        left 0
        top 0
        z-index 9
        background rgba(0,0,0, 0.3)
        transition .2s
    }
    .video-container {
        width 1400px
        height 800px
        position fixed
        left calc(50% - 700px)
        top calc(50% - 400px)
        z-index 10
        background rgba(54, 69, 103, 0.7)
        border 1px solid #1cc8fa
        border-radius 10px
        padding 10px 20px
        transition .2s
        .close {
            position absolute
            top 10px
            right 20px
            color #fff
            font-size 40px
            cursor pointer
            transition .2s
        }
        .close:hover {
            transform rotate(180deg)
        }
        .title {
            width 100%
            height 50px
            line-height 50px
            text-align center
            font-family 'PangMenZhengDao'
            font-size 32px
            color #1cc8fa
        }
        .camera-btn {
            width 100%
            height 32px
            /deep/ .ant-radio-group{
                display flex
                justify-content space-between
            }
            /deep/ .ant-radio-button-wrapper {
                background #00D6E1
                border-color #00D6E1
                color #0A5E78
                font-size 14px
                box-shadow 0 3px 6px rgba(0, 214, 225, 0.48)
                border-radius 7px
            }
            /deep/ .ant-radio-button-wrapper:not(:first-child)::before {
                width 0
            }
            /deep/ .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
                color #00d6e1
                background #007492
            }
        }
        .videos {
            width 100%
            height calc(100% - 102px)
            margin 10px 0
        }
    }
</style>